/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Sign_Out_FailedInputs */



/**
* | output |
* | --- |
* | "Could not sign out. Please try again." |
*
* @param {Layout_Header_Sign_Out_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_sign_out_failed = /** @type {((inputs?: Layout_Header_Sign_Out_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Sign_Out_FailedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abmelden fehlgeschlagen. Bitte versuche es erneut.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déconnexion impossible. Veuillez réessayer.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("无法退出登录，请重试。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("無法登出，請再試一次。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("로그아웃하지 못했습니다. 다시 시도하세요.")
	return /** @type {LocalizedString} */ ("Could not sign out. Please try again.")
});